export enum ImportStatementStateEnum {
  WaitingForStatement = "WAITING_FOR_STATEMENT",
  PreviewingStatement = "PREVIEWING_STATEMENT",
  ProcessingStatement = "PROCESSING_STATEMENT",
  ReviewExpensesFound = "REVIEW_EXPENSES_FOUND",
  StatementProcessed = "STATEMENT_PROCESSED",
}
